import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';
import { PostT } from '~/state/post';

const getPath = (uid?: string | number) => `/v2/organizations/${uid}/posts/featured`;

export async function apiGetV2OrganizationByIdPostsFeatured(uid?: string | number) {
  if (!uid) return;
  const response = await request.GET<{ posts: PostT[] }>(getPath(uid));
  return response.posts;
}

export function useSWRV2OrganizationByIdPostsFeatured(uid?: string | number) {
  const swr = useSWR(
    getPath(uid),
    () => apiGetV2OrganizationByIdPostsFeatured(uid),
    SWR_GLOBAL_CONFIG,
  );
  return { ...swr, featuredPosts: swr.data };
}
